import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import "./Spinner.css";
import "react-toastify/dist/ReactToastify.css";
import { Modal, Button } from "react-bootstrap";
import "./hm-theme.css";

const CreateAdminAccount = ({ isOpen, onRequestClose }) => {
  const navigate = useNavigate();
  const url = "/api/createAdminAccount";
  const [admin, setAdmin] = useState({
    username: "",
    role: "ROLE_ADMIN",
    firstname: "",
    lastname: "",
    phone: "",
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const token = JSON.parse(localStorage.getItem("data")).token;
    try {
      const emailCheckResponse = await axios.get(`/api/accounts/getByEmail=${admin.username}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (emailCheckResponse.data) {
        toast.error("Email already exists.");
        setLoading(false);
        return;
      }
    } catch (error) {
      handleError(error);
      setLoading(false);
      return;
    }

    axios.post(url, {
      username: admin.username,
      role: "ROLE_ADMIN",
      accBio: {
        email: admin.username,
        phone: admin.phone,
        firstname: admin.firstname,
        lastname: admin.lastname,
      }
    }, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(() => {
      setLoading(false);
      onRequestClose();
      setAdmin({ username: "", role: "ROLE_ADMIN", firstname: "", lastname: "", phone: "" });
      toast.success("Admin account created successfully. Password sent to their email.");
    }).catch((error) => {
      setLoading(false);
      handleError(error);
    });
  };

  function handleError(error) {
    if (error.response?.status === 401) {
      navigate(`/signin`);
      toast.error("Your session has expired. Please login.");
    } else {
      toast.error(error.response?.data?.message || error.message || "An error occurred.");
    }
  }

  function rhandle(e) {
    const { id, value } = e.target;
    setAdmin((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  }

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered>
      <Modal.Header closeButton className="hm-card-header">
        <Modal.Title className="hm-card-title">
          <i className="material-icons">admin_panel_settings</i>
          Create Admin Account
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {loading && <div className="loading"></div>}

        <div className="mb-2 p-2 rounded-3 d-flex align-items-center gap-2" style={{ background: "rgba(44, 182, 233, 0.08)", border: "1px solid rgba(44,182,233,0.2)" }}>
          <i className="material-icons text-info" style={{ fontSize: "1.1rem" }}>info</i>
          <span className="small text-muted">A temporary password will be sent to the admin's email address.</span>
        </div>

        <form onSubmit={handleSubmit} className="mt-3">
          <div className="mb-3">
            <label htmlFor="username" className="form-label small fw-semibold">
              Email Address <span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              id="username"
              type="email"
              placeholder="admin@example.com"
              value={admin.username}
              onChange={rhandle}
              required
            />
          </div>

          <div className="row g-3 mb-3">
            <div className="col-6">
              <label htmlFor="firstname" className="form-label small fw-semibold">
                First Name <span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                id="firstname"
                type="text"
                placeholder="First Name"
                value={admin.firstname}
                onChange={rhandle}
                required
              />
            </div>
            <div className="col-6">
              <label htmlFor="lastname" className="form-label small fw-semibold">
                Last Name
              </label>
              <input
                className="form-control"
                id="lastname"
                type="text"
                placeholder="Last Name"
                value={admin.lastname}
                onChange={rhandle}
              />
            </div>
          </div>

          <div className="mb-4">
            <label htmlFor="phone" className="form-label small fw-semibold">
              Contact Number <span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              id="phone"
              type="text"
              placeholder="+91 XXXXXXXXXX"
              value={admin.phone}
              onChange={rhandle}
              required
            />
          </div>

          <div className="d-flex justify-content-end gap-2">
            <Button variant="secondary" className="rounded-pill px-4" onClick={onRequestClose} disabled={loading}>
              Cancel
            </Button>
            <button type="submit" className="btn-hm-primary" disabled={loading}>
              <i className="material-icons" style={{ fontSize: "1rem" }}>person_add</i>
              Create Admin Account
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default CreateAdminAccount;
